<template>
  <div class="approval-out" v-loading="detailLoading" :style="{ height: heightAuto ? heightAuto : height + 'px' }">
    <div class="no-data" v-if="!processList || !processList.length">
      暂无审批信息
    </div>
    <ul class="approval-in" v-if="processList && processList.length">
      <li v-for="(item, index) in processList" :key="'process_' + index">
        <!-- :style="{ height: 120 * item.flows.length + 'px' }" -->
        <div class="approval-left">
          <div class="number" :style="{ backgroundColor: index === 0 && approvalTagLocal ? '#004098' : '#3c8d36' }">
            {{ processList.length - index }}
          </div>
          <div class="left-tail"></div>
        </div>
        <div class="approval-right">
          <div class="approval-card" v-for="flow in item.flows" :key="flow.taskDefId">
            <h3 :class="index === 1 && approvalTagLocal ? 'ccc' : 'title'">
              <span>{{ flow.taskName }}</span>
              <span v-if="flow.submitUserEmployee && flow.submitUserEmployee.name" :style="{ color: index === 1 && approvalTagLocal ? '#6736f2' : '#333' }">({{ flow.submitUserEmployee.name }})</span>
              <span v-else-if="flow.performersName" :style="{ color: index === 1 && approvalTagLocal? '#6736f2' : '#333' }">({{ flow.performersName }})</span>
            </h3>
            <div class="approval-content">
              <div class="approval-content__inner" :style="{ borderColor: index === 1 && approvalTagLocal ? '#3c8d36' : null }" >
                <div>
                  <span :class="index === 0 && approvalTagLocal ? 'first-suggestion' : 'suggestion'">处理意见:</span>
                  <span :style="{ color: flow.userRemark === '不同意' ? 'red' : null }" :class="index === 1 && approvalTagLocal ? 'ddd' : 'first-paragraph'">{{ flow.userRemark }}</span>
                </div>
                <div class="second-paragraph">
                  <span>处理日期:</span>
                  {{ flow.submitDate }}
                </div>
                <div class="second-paragraph">
                  <span>处理状态:&nbsp;&nbsp;</span>
                  <span class="status-tag" :class="flowStatus(flow.submitTypeDescription)">{{
                    flow.submitTypeDescription }}</span>
                </div>
              </div>
              <!-- <div class="status-tag" :class="{ 'retreat': flow.submitTypeDescription === '审批退回' }">{{
                flow.submitTypeDescription }}</div> -->
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { CorporationApi } from "../../../api/setup/index.js";
import Str from "../../../util/str";
const Api = new CorporationApi();
export default {
  name: "approval-logs",
  props: {
    processId: {
      type: String,
      required: true,
    },
    instId: {
      type: String,
      required: true,
    },
    height: {
      type: Number,
      default: 700,
    },
    heightAuto: {
      type: String,
      default: 'auto'
    },
    // 审批页面的标记，审批页面高亮当前审批的前一个节点
    approvalTag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      detailLoading: false,
      processList: [], //审批信息数据
      approvalTagLocal: false, // 本地状态，避免直接修改prop
    };
  },
  watch: {
    approvalTag:{
      handler(newVal) {
        this.approvalTagLocal = newVal ? true : false;
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    //获取页面数据
    this.getApprovalData();
  },
  methods: {
    //是否显示撤回审批
    handleRetreat(processList) {
      if (!processList || !processList.length) return
      //当前登录人包含在审批流最后两步的操作人中 && 最后一步的状态不是归档+到达
      let lastTwoFlows = processList.slice(0, 2), personList = []
      lastTwoFlows.forEach(item => {
        personList = personList.concat(item.flows.map(flow => flow.performersName))
      })
      let index = personList.findIndex(val => val === this.$store.state.user.userInfo.name)
      const { taskName, submitTypeDescription } = processList[0].flows && processList[0].flows[0]
      let overFlag = taskName === '归档' && submitTypeDescription === '到达'
      if ((taskName.indexOf("集团领导") != -1 || taskName.indexOf("分管外事领导") != -1) && submitTypeDescription === '到达') {
        this.$emit('update:isAgreeShow', false);
      }
      if ((taskName.indexOf("归档") != -1 || taskName.indexOf("开始") != -1) && submitTypeDescription === '到达') {
        this.$emit('update:isAgreeShow', true);
      }
      if (index > -1 && !overFlag) {
        this.$emit('updateLockbutton', false)//撤回审批可点击
      } else {
        this.$emit('updateLockbutton', true)
      }
    },
    getApprovalData() {
      this.detailLoading = true;
      Api.getDialog({
        processInstId: this.instId,
        processId: this.processId,
      }).then((res) => {
        this.detailLoading = false;
        this.processList = res.data;
        this.handleRetreat(this.processList)
      });
    },
    // 刷新流程意见数据
    refresh() {
      this.getApprovalData();
    },
    flowStatus(status) {
      switch (status) {
        case "审批退回":
          return 'error'
        case "重新发起":
          return 'retreat'
        case "审批通过":
          return 'success'
        case "到达":
          return 'reach'
        case "发起":
          return 'start'
        default:
          return ''
      }
    }
  },
};
</script>
<style lang="sass" scoped>
  @import "../style/process.sass"
</style>
